import imageCompression from 'browser-image-compression';

/**
 * Compresse une image avant upload.
 * Les photos de téléphone (5-15 Mo) sont réduites à ~1 Mo max.
 * 
 * @param {File} file - Le fichier image à compresser
 * @param {object} options - Options de compression
 * @param {number} options.maxSizeMB - Taille max en Mo (défaut: 1)
 * @param {number} options.maxWidthOrHeight - Dimension max en px (défaut: 1920)
 * @returns {Promise<File>} - Le fichier compressé
 */
export async function compressImage(file, options = {}) {
  // Ne pas compresser les fichiers non-image (ex: PDF pour pièce d'identité)
  if (!file.type.startsWith('image/')) {
    return file;
  }

  // Si le fichier fait déjà moins de 1 Mo, pas besoin de compresser
  const maxSizeMB = options.maxSizeMB || 1;
  if (file.size <= maxSizeMB * 1024 * 1024) {
    return file;
  }

  const compressionOptions = {
    maxSizeMB,
    maxWidthOrHeight: options.maxWidthOrHeight || 1920,
    useWebWorker: true,
    fileType: file.type === 'image/png' ? 'image/png' : 'image/jpeg',
  };

  const compressedFile = await imageCompression(file, compressionOptions);
  return compressedFile;
}
